// eslint-disable-next-line import/prefer-default-export
export const AUSTRALIAN_STATES = Object.freeze([
  { display: 'ACT', returnValue: 'ACT' },
  { display: 'NSW', returnValue: 'NSW' },
  { display: 'NT', returnValue: 'NT' },
  { display: 'QLD', returnValue: 'QLD' },
  { display: 'SA', returnValue: 'SA' },
  { display: 'TAS', returnValue: 'TAS' },
  { display: 'VIC', returnValue: 'VIC' },
  { display: 'WA', returnValue: 'WA' },
]);

export const MAX_PAYMENT_AMOUNT = Number(20500).toFixed(2);

export const MAX_POSTCODE_LENGTH = 4;

export const GO_LIVE_DATE = '2023-07-24';

export const ACCEPTED_CARDS = ['diners', 'discover', 'jcb', 'mastercard', 'visa', 'maestro'];

export const MIGRATION_DATE = '2021-07-01';
